import React from 'react';
import { ImageBadge } from 'seduo-ui';
const Example = () => (<>
        <div className="d-flex p-5 mb-5">
            <ImageBadge text="Dark" theme="dark"/>
            <ImageBadge icon="webinar" text="Dark with color icon" color="danger" theme="dark"/>
            <ImageBadge icon="education" text="Dark with icon" theme="dark"/>
        </div>
        <div className="d-flex bg-brand-dark p-5">
            <ImageBadge text="Light"/>
            <ImageBadge icon="webinar" text="Light with icon" color="danger"/>
            <ImageBadge icon="education" text="With band light color" color="brand-light"/>
            <ImageBadge icon="education" text="With custom color" hex="#97ebdb"/>
        </div>
    </>);
export default Example;
